<template>
  <div>
    <div class="md-layout md-gutter">
      <spinner :load="load" />

      <div v-if="!load && isEmpty" class="md-layout-item md-size-100">
        <md-empty-state>
          <md-icon class="md-size-5x">
            <img src="@/assets/icons/add.svg" alt="add">
          </md-icon>
          <h1>{{ $t('home.firstPlot') }}</h1>
          <md-button class="md-primary md-raised" @click="goAddPlot()">{{ $t('global.add') }} {{ $t('page.plot') }}</md-button>
        </md-empty-state>
      </div>

      <div class="md-layout-item md-size-100" v-if="!load && loadData">
        <b-tabs v-model="tabIndex" content-class="mt-3" active-nav-item-class="tab-active" fill v-touch:swipe="swipeHandler">
          <b-tab :title="$t('page.plot')" title-link-class="tab" active>
            <plot-list :data="forestPlot" :db="measurements" type="01" :step="firstStep" @remove="checkPlotList" v-if="loadData"></plot-list>
          </b-tab>
          <b-tab :title="$t('page.event')" title-link-class="tab">
            <plot-list :data="eventPlot" :db="measurements" type="02" :step="firstStep" @remove="checkPlotList" v-if="loadData"></plot-list>
          </b-tab>
        </b-tabs>
      </div>
    </div>
    <div v-if="loadData" class="md-layout md-gutter md-size-100 md-alignment-center-right">
      <div class="md-layout-item md-size-25">
        <md-button class="md-fab md-primary btn-add" @click="goAddPlot()">
          <md-icon>add</md-icon>
        </md-button>
      </div>
    </div>
  </div>
</template>

<script>
import PlotList from '@/components/PlotList'
import Spinner from '@/components/Spinner'

import clearState from '@/assets/scripts/clearState'

export default {
  props: ['measurements', 'update'],
  components: {
    PlotList,
    Spinner
  },
  data: () => ({
    // measurementsData: [],
    forestPlot: [],
    eventPlot: [],
    isEmpty: false,
    load: false,
    loadData: false,
    firstStep: 'Team',
    tabIndex: 0
  }),
  async mounted () {
    this.$emit('title', this.$i18n.t('home.listPlot'))
    this.$store.commit('plot/setId', null)

    if (this.measurements !== undefined) {
      this.getMeasurements()
    }
  },
  watch: {
    measurements: function () {
      this.getMeasurements()
    },

    update: function () {
      this.getMeasurements()
    }
  },
  methods: {
    goAddPlot: function () {
      clearState()
      this.$router.push(this.firstStep)
    },

    getMeasurements: function () {
      this.load = true
      this.forestPlot = []
      this.eventPlot = []
      this.measurements.length().then(length => {
        if (length > 0) {
          this.measurements.iterate((value, key, iterationNumber) => {
            if (value.localization.plotType === this.$store.state.plotTypeLoc.forestPlot) this.forestPlot.push({ id: key, value: value })
            if (value.localization.plotType === this.$store.state.plotTypeLoc.eventPlot) this.eventPlot.push({ id: key, value: value })
          }).then(() => {
            this.forestPlot.sort((a, b) => this.sortPlot(a, b, 'plot_num'))
            this.eventPlot.sort((a, b) => this.sortPlot(a, b, 'event_num'))
            this.load = false
            this.isEmpty = false
            this.loadData = true
          }).catch(err => {
            console.log(err)
          })
        } else {
          this.load = false
          this.loadData = false
          this.isEmpty = true
        }
      }).catch(err => {
        console.log(err)
      })
    },

    swipeHandler (direction) {
      if (direction === 'left' && this.tabIndex === 0) {
        this.tabIndex = 1
      }
      if (direction === 'right' && this.tabIndex === 1) {
        this.tabIndex = 0
      }
    },

    checkPlotList: function () {
      this.loadData = false
      this.isEmpty = false
      this.getMeasurements()
    },

    sortPlot: function (a, b, type) {
      if (a.value.localization.parcel === b.value.localization.parcel) {
        if (a.value.localization.sub_parcel === b.value.localization.sub_parcel) {
          if (a.value.localization.dt_update === b.value.localization.dt_update) {
            return a.value.plot[type] - b.value.plot[type]
          }
          return new Date(b.value.localization.dt_update) > new Date(a.value.localization.dt_update) ? 1 : -1
        } else {
          return a.value.localization.sub_parcel > b.value.localization.sub_parcel ? 1 : -1
        }
      }
      return a.value.localization.parcel - b.value.localization.parcel
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/style/arcadia_theme.scss';

  .btn-add {
    float: right;
  }
</style>
